// library imports
import { useDispatch } from "react-redux";

// User Component imports
import { ExecOpsRequest } from "apis/AdminOpsApiCommon";

// 運営ツール: 利用設定の取得
const AdminOpsConfigGetApi = () => {
    const dispatch = useDispatch();
    const url = "/admin/ops_config_get";

    const ExecAdminOpsConfigGetApi = async () => {
        return ExecOpsRequest(dispatch, { url: url, requestParams: {} });
    };

    return ExecAdminOpsConfigGetApi;
};

export default AdminOpsConfigGetApi;
